import { CustomPopover } from '@aibees/shared/components';
import { Dialog as MuiDialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Popover = styled(CustomPopover)``;

export const Dialog = styled(MuiDialog)``;
